import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
  signal
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalComponent } from '@view/shared/molecules/modal/modal.component';
import { ButtonComponent } from '@view/shared/molecules/button/button.component';
import {
  ButtonTypeEnum,
  ButtonSizeEnum
} from '@view/shared/molecules/button/buttonTypesEnum';
import { CaseListItem } from '@model/traceability/traceability.model';

export interface PrioritizationResult {
  prioritization: boolean;
  prioritizationReason: string | null;
}

@Component({
  selector: 'app-prioritization-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, ModalComponent, ButtonComponent],
  templateUrl: './prioritization-modal.component.html',
  styleUrls: ['./prioritization-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrioritizationModalComponent {
  readonly caseItem = input.required<CaseListItem>();
  readonly isSaving = input<boolean>(false);

  readonly closeModal = output<void>();
  readonly save = output<PrioritizationResult>();

  readonly ButtonTypeEnum = ButtonTypeEnum;
  readonly ButtonSizeEnum = ButtonSizeEnum;

  prioritized = signal(false);
  reason = signal('');

  ngOnInit(): void {
    const item = this.caseItem();
    this.prioritized.set(item.prioritization ?? false);
    this.reason.set(item.prioritizationReason ?? '');
  }

  onTogglePrioritization(value: boolean): void {
    this.prioritized.set(value);
    if (!value) {
      this.reason.set('');
    }
  }

  onSave(): void {
    this.save.emit({
      prioritization: this.prioritized(),
      prioritizationReason: this.prioritized() ? (this.reason() || null) : null
    });
  }

  onClose(): void {
    this.closeModal.emit();
  }
}
